import { BRAND } from "./config"

type EnvironmentBadge = {
  prefix: string
  favicon: string
}

// Stable keeps the plain favicon and title from index.html.
const ENVIRONMENT_BADGES: Record<string, EnvironmentBadge> = {
  local: { prefix: "λ", favicon: "/favicon-sentrisense-local.svg" },
  alpha: { prefix: "α", favicon: "/favicon-sentrisense-alpha.svg" },
  beta: { prefix: "β", favicon: "/favicon-sentrisense-beta.svg" },
}

const badge = ENVIRONMENT_BADGES[BRAND]

export const withEnvironmentPrefix = (title: string): string =>
  badge ? `${badge.prefix} · ${title}` : title

export function initEnvironmentBadge() {
  if (!badge) return

  // Drop every stable icon, otherwise the browser can keep using one of them.
  document.querySelectorAll('link[rel~="icon"]').forEach((link) => link.remove())
  const favicon = document.createElement("link")
  favicon.rel = "icon"
  favicon.type = "image/svg+xml"
  favicon.href = badge.favicon
  document.head.appendChild(favicon)

  document.title = withEnvironmentPrefix(document.title)
}
